export const LOAD_PRACTITIONERS = 'LOAD_PRACTITIONERS';
